import { render, staticRenderFns } from "./ReorderParamSetting.vue?vue&type=template&id=79876094&scoped=true"
import script from "./ReorderParamSetting.vue?vue&type=script&lang=ts"
export * from "./ReorderParamSetting.vue?vue&type=script&lang=ts"
import style0 from "./ReorderParamSetting.vue?vue&type=style&index=0&id=79876094&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79876094",
  null
  
)

export default component.exports